import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** Payer status create and update APIs request body - DTO signature */
export interface PayerStatusFormInterface {
  /** Payer status unique code */
  code: string;
  /** Payer status display name */
  name: string;
  /** Payer status expiration mark */
  expired?: boolean;
}

/** Payer status create and update APIs request body - DTO schema */
export const PayerStatusFormDto = SerdeDtoClass.create<PayerStatusFormInterface>(CatalogDtosKeysEnum.PAYER_STATUS_FORM_DTO, {
  code: {
    sortable: true,
    label: 'Код',
    serializer: yup
      .string()
      .matches(/^\d+$/im, 'Код статус плательщика должен может содержать только цифры'),
    checkers: [CatalogCheckersEnum.PAYER_STATUS_CODE_UNIQUE],
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  expired: {
    optional: true,
    label: 'Устаревший статус',
    hint: 'Пометка для устаревших статусов плательщика (такое может быть, так как наборы статусов периодически меняются)',
    serializer: yup.boolean(),
  },
});
